import React from 'react';

import { useFeatureFlags } from '@tcc/shared-data-lib';
import { importFromS3 } from '../../utils/importFromS3';
import { useFeatureFlagsConfigs } from '../../utils/sharedData';
import { Operation } from '../../hooks/useOperations/types';
import { useImpersonatedOperation } from '../../hooks/useImpersonatedOperation';

interface FixitToolPluginContainerProps {
  operationsSelected: Operation[]
}

const S3Plugin = React.lazy(() => importFromS3('fixit-tool'));
const MFPlugin = React.lazy(() => import('fixitTool/FixitTool'));

export const FixitToolPluginContainer: React.FC<FixitToolPluginContainerProps> = ({ operationsSelected }: FixitToolPluginContainerProps) => {
  const { featureFlags } = useFeatureFlags(useFeatureFlagsConfigs());
  const useModuleFederation = featureFlags?.['web.fixitTool.module-federation'];

  const FixitToolPlugin = useModuleFederation ? MFPlugin : S3Plugin;

  const { isLoading, operation } = useImpersonatedOperation();
  const operationSelected = operation || operationsSelected[0];

  // prevent rendering Fixit Tool if we're fetching operations
  if (isLoading || !operationSelected?.operationOwnerId) return null;

  return (
    <FixitToolPlugin
      operationSelected={operationSelected}
    />
  );
};
